import { render, staticRenderFns } from "./MenuTitle.vue?vue&type=template&id=66e5ebc2&scoped=true&"
import script from "./MenuTitle.vue?vue&type=script&lang=js&"
export * from "./MenuTitle.vue?vue&type=script&lang=js&"
import style0 from "./MenuTitle.vue?vue&type=style&index=0&id=66e5ebc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5ebc2",
  null
  
)

export default component.exports